export var CustomServiceClass;
(function (CustomServiceClass) {
    CustomServiceClass["Free"] = "Free";
})(CustomServiceClass || (CustomServiceClass = {}));
export var CustomSeatComfort;
(function (CustomSeatComfort) {
    CustomSeatComfort["Free"] = "Free";
    CustomSeatComfort["Unavaliable"] = "Unavaliable";
})(CustomSeatComfort || (CustomSeatComfort = {}));
